export { useTenantConfigs, getCountryConfiguration, getCountryConfigurationByStorage } from './useTenantConfigs'
